export const userActionTypes = {
  FETCH_USER_START: "FETCH_USER_START",
  FETCH_USER_SUCCESS: "FETCH_USER_SUCCESS",
  FETCH_USER_ERROR: "FETCH_USER_ERROR",
};

export const collectionActionTypes = {
  FETCH_COLLECTION_START: "FETCH_COLLECTION_START",
  FETCH_COLLECTION_SUCCESS: "FETCH_COLLECTION_SUCCESS",
  FETCH_COLLECTION_ERROR: "FETCH_COLLECTION_ERROR",
};

export const collectionsActionTypes = {
  FETCH_COLLECTIONS_START: "FETCH_COLLECTIONS_START",
  FETCH_COLLECTIONS_SUCCESS: "FETCH_COLLECTIONS_SUCCESS",
  FETCH_COLLECTIONS_ERROR: "FETCH_COLLECTIONS_ERROR",
  FETCH_BIGCOLLECTIONS_START: "FETCH_BIGCOLLECTIONS_START",
  FETCH_BIGCOLLECTIONS_SUCCESS: "FETCH_BIGCOLLECTIONS_SUCCESS",
  FETCH_BIGCOLLECTIONS_ERROR: "FETCH_BIGCOLLECTIONS_ERROR",
  DELETE_START: "DELETE_START",
  DELETE_SUCCESS: "DELETE_SUCCESS",
  DELETE_ERROR: "DELETE_ERROR",
  FETCH_VALUE_FOR_EDIT_START: "FETCH_VALUE_FOR_EDIT_START",
  FETCH_VALUE_FOR_EDIT_SUCCESS: "FETCH_VALUE_FOR_EDIT_SUCCESS",
  FETCH_VALUE_FOR_EDIT_ERROR: "FETCH_VALUE_FOR_EDIT_ERROR",
  CREATE_COLLECTION_START: "CREATE_COLLECTION_START",
  CREATE_COLLECTION_SUCCESS: "CREATE_COLLECTION_SUCCESS",
  UPDATE_COLLECTION_SUCCESS: "UPDATE_COLLECTION_SUCCESS",
  CLOSE_FORM: "CLOSE_FORM"
};

export const itemsActionTypes = {
  DELETE_START: "DELETE_START",
  DELETE_SUCCESS: "DELETE_SUCCESS",
  DELETE_ITEMS_START: "DELETE_ITEMS_START",
  DELETE_ITEMS_SUCCESS: "DELETE_ITEMS_SUCCESS",
  DELETE_ERROR: "DELETE_ERROR",
  FETCH_VALUE_FOR_EDIT_START: "FETCH_VALUE_FOR_EDIT_START",
  FETCH_VALUE_FOR_EDIT_SUCCESS: "FETCH_VALUE_FOR_EDIT_SUCCESS",
  FETCH_VALUE_FOR_EDIT_ERROR: "FETCH_VALUE_FOR_EDIT_ERROR",
  CREATE_ITEM_START: "CREATE_ITEM_START",
  CLOSE_FORM: "CLOSE_FORM"
};

export const adminActionTypes = {
  FETCH_USERS_START: "FETCH_USERS_START",
  FETCH_USERS_SUCCESS: "FETCH_USERS_SUCCESS",
  FETCH_USERS_ERROR: "FETCH_USERS_ERROR",
  BLOCK_START: "BLOCK_START",
  MAKEADMIN_START: "MAKEADMIN_START",
  UPDATE_SUCCESS: "UPDATE_SUCCESS",
  DELETE_START: "DELETE_START",
  DELETE_SUCCESS: "DELETE_SUCCESS",
  DELETE_USERS_START: "DELETE_USERS_START",
  DELETE_USERS_SUCCESS: "DELETE_USERS_SUCCESS",
  UPDATE_ERROR: "UPDATE_ERROR"
};

export const tagsActionTypes = {
  FETCH_TAGS_START: "FETCH_TAGS_START",
  FETCH_TAGS_SUCCESS: "FETCH_TAGS_SUCCESS",
  FETCH_TAGS_ERROR: "FETCH_TAGS_ERROR"
};

export const authActionTypes = {
  CHANGESTATUS_ADMIN: "CHANGESTATUS_ADMIN",
  CHANGESTATUS_USER: "CHANGESTATUS_USER",
  REMOVE_AUTHDATA: "REMOVE_AUTHDATA"
};

export const commentsActionTypes = {
  FETCH_COMMENTS_START: "FETCH_COMMENTS_START",
  FETCH_COMMENTS_SUCCESS: "FETCH_COMMENTS_SUCCESS",
  FETCH_COMMENTS_ERROR: "FETCH_COMMENTS_ERROR",
  UPDATE_COMMENTS: "UPDATE_COMMENTS"
};

export const likesActionTypes = {
  FETCH_LIKES_SUCCESS: "FETCH_LIKES_SUCCESS",
  FETCH_LIKES_ERROR: "FETCH_LIKES_ERROR",
  ADD_LIKE_START: "ADD_LIKE_START",
  ADD_LIKE_SUCCESS: "ADD_LIKE_SUCCESS",
  ADD_LIKE_ERROR: "ADD_LIKE_ERROR",
  REMOVE_LIKE_START: "REMOVE_LIKE_START",
  REMOVE_LIKE_SUCCESS: "REMOVE_LIKE_SUCCESS",
  REMOVE_LIKE_ERROR: "REMOVE_LIKE_ERROR",
  CHECK_LIKE: "CHECK_LIKE"
};

export const oprionsActionTypes = {
  CHANGE_MODE: "CHANGE_MODE",
  CHANGE_LANG: "CHANGE_LANG"
};